import Button from 'components/Button';
import Chip from 'components/Chip';
import DownloadIcon from 'components/icons/Download';
import { HeadButtons, PageHeadContainer, PageTitle } from 'components/PageHead';
import { FC, useContext } from 'react';
import { Link } from 'react-router-dom';
import { BinomesContext } from '..';

const Head: FC = () => {
  const { count, filteredCount } = useContext(BinomesContext);

  return (
    <PageHeadContainer>
      <PageTitle>
        <h1>Binômes</h1>
        <Chip color="var(--primary-700)" bgColor="var(--primary-50)">
          {count && typeof filteredCount === 'number'
            ? count === filteredCount
              ? count
              : `${filteredCount}/${count}`
            : ''}
        </Chip>
      </PageTitle>
      <HeadButtons>
        <Link to="export">
          <Button variant="outlined" icon={<DownloadIcon />}>
            Exporter la liste
          </Button>
        </Link>
      </HeadButtons>
    </PageHeadContainer>
  );
};

export default Head;